import React from 'react'
import Hafeez from "../hafeez..jpeg"

const ProjData = [
    {
    img:{Hafeez},
    project:"https://resultcheck-1.web.app/"
    },
]

const backProject = [
    {
        project:"https://github.com/Hafeezdeveloper/Backend-two"
    },
    {
        project:"https://github.com/Hafeezdeveloper/Backend-Auth"
        }
    
]
export  {ProjData,backProject}
